import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';


import * as RegUsrActions from '../../actions';
import { ConfigService } from 'src/config/config.service';
import { cuenta } from 'src/app/models/SicarMap/cuenta.model';
import { AuthService } from 'src/app/services/SicarMap/auth.service';


@Injectable()
export class regusrEffects {

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private config: ConfigService,
    private router: Router
  ) {}

  // effects go here
    @Effect()
    ExecRegistro$: Observable<any> = this.actions$.pipe(
        ofType(RegUsrActions.RegUsrActionTypes.REGISTRO),
        switchMap((action: RegUsrActions.ExecRegistro) => {
            return this.authService.RegistrarUsuario(action.Credenciales)
                .pipe(
                    map((TokenActive: any) => {
                        localStorage.setItem('token', TokenActive.token);
                        this.authService.Usuario.pidperfil = TokenActive.perfilActivo;
                        return new RegUsrActions.RegistroSuccess(TokenActive);
                    }),
                    catchError(error => of (new RegUsrActions.RegistroFailure({ error })))
                );
            }
        )
    );
}
